<ng-container *ngIf="{ ends: ends$ | async, expired: expired$ | async } as sub">
  <div
    class="update-notice d-flex justify-content-center"
    *ngIf="sub.ends > 0 || sub.expired"
  >
    <!-- Expired -->
    <div
      *ngIf="sub.expired; else notExpired"
      class="alert alert-warning text-center small ng-cloak mx-auto mb-0 mt-1"
    >
      {{
        'apollo-subscription.subscription-expiration-banner.expired.notice'
          | translate
      }},

      <a
        *ngIf="activeOrganization | async as organization"
        href
        [routerLink]="['/', organization.id, 'subscriptions', 'plans']"
        >{{
          'apollo-subscription.subscription-expiration-banner.expired.link'
            | translate
        }}</a
      >.
    </div>

    <ng-template #notExpired>
      <div
        class="alert alert-primary text-center small ng-cloak mx-auto mb-0 mt-1"
      >
        {{
          'apollo-subscription.subscription-expiration-banner.trial.notice'
            | translate: { days: sub.ends }
        }}
      </div>
    </ng-template>
  </div>
</ng-container>
